import { activateAccount, postRegister } from "../../../helpers/api";
import { all, fork, takeEvery, put, call } from "redux-saga/effects";
import {
  registerCompanyError,
  registerCompanySuccess,
  registerPersonalUserError,
  registerPersonalUserSuccess,
} from "../../actions";
import { togglePageLoader } from "../../actions";
import {
  ACTIVATE_ACCOUNT,
  REGISTER_COMPANY,
  REGISTER_PERSONALUSER,
} from "./actionTypes";
import { notifications } from "@mantine/notifications";

// Is user register successfull then direct plot user in redux.
function* registerCompany({ payload: { data, history } }) {
  localStorage.removeItem("authUser");
  try {
    yield put(togglePageLoader(true));
    const response = yield call(postRegister, data);
    console.log("REGISTER COMPANY RESPONSE ------", response);
    if (response.status === "Success") {
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(registerCompanySuccess(response));
      yield put(togglePageLoader(false));
      // history.push("/verifyscreen");
    } else {
      yield put(registerCompanyError(response));
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    console.log("Errrorr ", error);
    yield put(togglePageLoader(false));
    localStorage.removeItem("authUser");
    yield put(registerCompanyError(error));
  }
}

function* registerPersonalUser({ payload: { data, history } }) {
  localStorage.removeItem("authUser");
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const response = yield call(postRegister, data);
    if (response.status === "Success") {
      localStorage.setItem("authUser", JSON.stringify(response));
      notificationColor = "lime";
      yield put(registerPersonalUserSuccess(response));
      yield put(togglePageLoader(false));
      // history.push("/verifyscreen");
    } else {
      notificationColor = "red";
      yield put(registerPersonalUserError(response));
      yield put(togglePageLoader(false));
    }
    if (notifications && notifications.show) {
      // notification setup
      notifications.show({
        title: "Register Profile",
        message: response.title || response.message,
        color: notificationColor,
      });
    }
  } catch (error) {
    yield put(togglePageLoader(false));
    localStorage.removeItem("authUser");
    yield put(registerPersonalUserError(error));
  }
}

function* activateAccountSagas({ payload: { data, history } }) {
  localStorage.removeItem("authUser");
  try {
    yield put(togglePageLoader(true));
    const response = yield call(activateAccount, data);
    let notificationColor;
    if (response.status === "Success") {
      // notificationColor = 'red';
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(registerCompanySuccess(response));
    } else {
      notificationColor = response?.user == null ? "red" : "lime";
      yield put(registerCompanyError(response));
    }
    // if (notifications && notifications.show) {
    //   // notification setup
    //   notifications.show({
    //     title: "Account Activation",
    //     message: response.status,
    //     color: notificationColor,
    //   });
    // }
    // automatically direct to login page 
    // setTimeout(() => {
    //   history?.push("/login");
    // }, 4000);
    yield put(togglePageLoader(false));
  } catch (error) {
    console.error("Error", error);
    yield put(togglePageLoader(false));
    localStorage.removeItem("authUser");
    yield put(registerCompanyError(error));
  }
}

function* accountSaga() {
  yield takeEvery(REGISTER_COMPANY, registerCompany);
  yield takeEvery(REGISTER_PERSONALUSER, registerPersonalUser);
  yield takeEvery(ACTIVATE_ACCOUNT, activateAccountSagas);
}

export default accountSaga;
